import type { TFunction } from 'i18next'
import type { SprintEmailContent } from '../../../../../../../pure-js/types/Sprint'
import { buildSprintInviteBody, type SprintInviteCopy } from '../../../../../../../pure-js/libs/sprintInviteEmail'

const T_PREFIX = 'facilitator.trainingSprint.previewAndLaunch.emailContent'

const COPY_KEYS: (keyof SprintInviteCopy)[] = [
  'greeting',
  'introduction',
  'howItWorksDescription',
  'sprintScheduleTitle',
  'equipmentTitle',
  'equipmentDescription',
  'createAccountTitle',
  'createAccountDescription',
  'prepareTitle',
  'prepareDescription',
  'questionsText',
  'faqLink',
  'questionsOr',
  'userGuideLink',
  'closingMessage',
  'closingSignature'
]

/**
 * The wizard's copy of the invite, translated. The markup itself lives in `pure-js` so the body the
 * facilitator previews here is the same one the server sends when they never open this editor.
 */
export function buildDefaultEmailContent(t: TFunction): SprintEmailContent {
  const copy = Object.fromEntries(COPY_KEYS.map((key) => [key, t(`${T_PREFIX}.${key}`)])) as SprintInviteCopy

  return buildSprintInviteBody(copy)
}

/**
 * Default equipment text block for the "Insert Equipment" toolbar pill.
 */
export function getEquipmentText(t: TFunction): string {
  return [
    `<p><strong>${t(`${T_PREFIX}.equipmentTitle`)}</strong></p>`,
    `<p>${t(`${T_PREFIX}.equipmentDescription`)}</p>`
  ].join('')
}
